export default {
  "index": {
    "updateInformationTo": "Failed to update information to ONCALL, please try again later"
  }
}